<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg5>
            <h2>Onechat</h2>
          </v-flex>
          <v-flex xs11 lg6 class="text-end">
            <!-- <v-btn
              color="#077893"
              rounded
              dark
              small
              @click="Fn_SyncBot"
              :loading="LoadingSync"
            >
              Import Excel
            </v-btn> -->
          </v-flex>
        </v-layout>
        <!-- <b class="red--text mr-1">*</b>
            <b
              v-if="$t('default') === 'th'"
              class="red--text mr-1"
              style="font-size: 0.8rem"
              >เพิ่ม BOT CMP ให้กับทุกคนใน Business</b
            >
            <b v-else class="red--text mr-1" style="font-size: 0.8rem"
              >Add BOT CMP to everyone in business</b
            > -->

        <v-layout row wrap justify-center align-center pt-3 pb-3>
          <v-flex xs11 lg11>
            <v-card class="rounded-lg pb-2">
              <v-tabs v-model="tab" align-with-title color="#077893">
                <v-tabs-slider color="#077893"></v-tabs-slider>

                <v-tab v-for="item in items" :key="item">
                  {{ $t(item) }}
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <EmployeeOneID />
                </v-tab-item>
                <v-tab-item>
                  <EmployeeCMP />
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-flex>
        </v-layout>

        <!-- <SearchConsentLogOnechatIndex /> -->
        <SendOnechatDetail />

        <!-- <LogOnechat /> -->
      </v-container>
      <div v-if="loadingDownloadData">
        <OverlaySearch />
      </div>
      <DialogListGeneralConsent
        :show="DialogList"
        :_detail="ItemsListConsent"
        @closeDialogDelete="DialogList = false"
      />
      <DialogListGroupConsent
        :show="DialogListGroup"
        :_detail="ItemsListConsent"
        @closeDialogDelete="DialogListGroup = false"
      />
      <DialogTypeDepartment
        :show="DialogTypeDepartment"
        :typeDepartment="SelectDepartment"
        @closeDialog="DialogTypeDepartment = false"
        @confirmAccount="Fn_ConfirmEmployee"
      />
      <DialogAllEmployee
        :show="DialogAllEmployee"
        :typeDepartment="SelectNamePosition"
        @closeDialog="DialogAllEmployee = false"
        @confirmEmployee="Fn_ConfirmEmployee"
      />
    </v-main>
  </v-app>
</template>

<script>
import DialogAllEmployee from "@/components/dialog/ConsentOnechat/DialogConsentAllEmployee.vue";
import DialogListGeneralConsent from "@/components/dialog/ConsentOnechat/DialogConsentGeneralOnechatCreate.vue";
import DialogListGroupConsent from "@/components/dialog/DialogConsentGroupOnechatCreate";
import DialogTypeDepartment from "@/components/dialog/DialogConsentTypeDepartment.vue";
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import authorization from "@/functions/authorization.js";
import EmployeeCMP from "@/views/Admin/Consent/ConsentOnechat/OneAccount/EmployeeCMP.vue";
import EmployeeOneID from "@/views/Admin/Consent/ConsentOnechat/OneAccount/EmployeeOneID.vue";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import { mapGetters } from "vuex";
import SendOnechatDetail from "./LogOnechat/SendOnechatDetail.vue";
// import LogOnechat from '../ConsentOnechat/LogOnechat/ConsentLogOnechatIndex.vue'
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: {
    OverlaySearch,
    EmployeeCMP,
    EmployeeOneID,
    DialogListGeneralConsent,
    DialogListGroupConsent,
    // LogOnechat,
    DialogTypeDepartment,
    DialogAllEmployee,
    // SearchConsentLogOnechatIndex,
    SendOnechatDetail,
  },
  data: function () {
    return {
      tab: null,
      items: [this.$t("onechat.new1"), this.$t("onechat.new2")],
      Page: 1,
      PageCount: 0,
      ItemPerPage: 10,
      valid: true,
      LoadingExcel: false,
      DialogList: false,
      DialogTypeDepartment: false,
      DialogAllEmployee: false,
      loadingDownloadData: true,
      Title: "",
      RejectReason: "",
      DetailConsent: "",
      ExpirationDate: "",
      DepartmentId: "",
      ConsentType: "SentGeneral",
      DisabledPosition: false,
      SelectNamePosition: [],
      TypeSent: "",
      LoadingPosition: false,
      LoadingSentConsent: false,
      DialogListGroup: false,
      StatusBtn: 1,
      rows: [{ row: "" }],
      ItemsRole: [],
      ItemsDepartment: [],
      ItemsPosition: [],
      ItemPolicy: [],
      ItemConsentGeneral: [],
      ItemConsentGroup: [],
      ItemsListConsent: [],
      SelectPolicy: "",
      SelectConsentGeneral: "",
      SelectConsentGroup: " ",
      SelectDepartment: "",
      SelectRole: "",
      TextPolicy: "",
      TextConsent: "",
      Search: "",
      LoadingSync: false,
    };
  },
  computed: {
    ...mapGetters(["Business"]),
    ...mapGetters(["RoleAccount"]),

    _RoleAccount: {
      get() {
        return this.RoleAccount || "-";
      },
    },
    _SelectBusinessId: {
      get() {
        return this.Business.BusinessId || "-";
      },
    },
    _SelectTaxId: {
      get() {
        return this.Business.TaxId || "-";
      },
    },
    _SelectAccessToken: {
      get() {
        return this.$cookies.get("OneAccessToken") || "-";
      },
    },
    _BusinessName: {
      get() {
        return this.Business.BusinessNameTH || "-";
      },
    },
    HeadersRole() {
      return [
        {
          text: "ทุกคน",
          align: "start",
          sortable: false,
          value: "Name",
        },
      ];
    },
    HeadersPosition() {
      return [
        {
          text: "ทุกตำแหน่ง",
          align: "start",
          sortable: false,
          value: "Name",
        },
      ];
    },
  },
  mounted() {
    this.Fn_ChangeTypeText();
    setTimeout(() => (this.loadingDownloadData = false), 500);
  },
  methods: {
    Fn_ChangeTypeText() {
      if (this.ConsentType === "SentGeneral") {
        this.TextPolicy = "เลือกนโยบายแบบทั่วไป";
        this.TextConsent = "เลือกความยินยอมแบบทั่วไป";
      } else if (this.ConsentType === "SentGroup") {
        this.TextPolicy = "เลือกนโยบายแบบกลุ่ม";
        this.TextConsent = "เลือกความยินยอมแบบกลุ่ม";
      }
    },
    Fn_BackIndex() {
      this.$router.push("/consent-index-create");
    },
    Fn_SelectTypeDepartment() {
      if (this.TypeSent === "SentDepartment") {
        // this.Fn_GetAllDepartment()
        this.DialogTypeDepartment = true;
      } else if (this.TypeSent === "SentAll") {
        this.SelectDepartment = "";
        this.SelectRole = "";
        this.DialogAllEmployee = true;
        this.$refs.formConsent.resetValidation();
        // this.Fn_GetAllEmployee()
      }
    },

    Fn_NextPage() {
      this.StatusBtn = 2;
      this.Fn_SelectTypeConsent();
    },
    Fn_SelectTypeConsent() {
      if (this.ConsentType === "SentGeneral") {
        // this.SelectPolicy = ''
        // this.SelectConsentGeneral = ''
        // this.$refs.formConsent.resetValidation()
        this.Fn_GetPolicy();
        this.Fn_GetConsentGeneral();
      } else if (this.ConsentType === "SentGroup") {
        // this.SelectConsentGroup = ''
        // this.$refs.formConsent.resetValidation()
        this.Fn_GetConsentGroup();
      }
    },
    async Fn_GetAllDepartment() {
      var payload = {
        TaxId: this._SelectTaxId,
        AccessToken: this.$cookies.get("OneAccessToken"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "business/GetAllDepartment",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            for (var i in response.data.Message) {
              var x = response.data.Message[i];
              this.ItemsDepartment.push(x);
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetDetailDepartment() {
      this.LoadingPosition = true;
      this.ItemsRole = [];

      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccessToken: this.$cookies.get("OneAccessToken"),
        DepartmentId: this.SelectDepartment.DepartmentId,
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "business/GetDetailDepartment",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.LoadingPosition = false;
          if (response.data.Status === "OK") {
            for (var i in response.data.Message) {
              var x = response.data.Message[i];
              this.ItemsRole.push(x);
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.LoadingPosition = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: this.$i18n.t("alert.catch"),
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetAllEmployee() {
      // if (this.TypeSent == "SentAll") {
      this.LoadingPosition = true;
      // this.SelectNamePosition = []
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccessToken: this.$cookies.get("OneAccessToken"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
        PerPage: this.ItemPerPage,
        Page: this.Page,
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "business/employee/all",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.LoadingPosition = false;
          if (response.data.Status === "OK") {
            this.ItemsPosition = response.data.Message.Employee;
            // for (var i in response.data.Message.Employee
            // ) {
            //   var x = response.data.Message[i]
            //   this.ItemsPosition.push(x)
            // }
            var startPage = this.Page * this.ItemPerPage - this.ItemPerPage + 1;
            var nextPage = startPage + this.ItemsPosition.length;

            var number = [];
            for (var i = startPage; i < nextPage; i++) {
              number.push(i);
            }
            for (var j in this.ItemsPosition) {
              this.ItemsPosition[j].no = number[j];
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.LoadingPosition = false;

          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
      // } else {
      //   Toast.fire({
      //     icon: "warning",
      //     title: "กรุณาเลือกรูปแบบการส่ง",
      //   });
      // }
    },
    async Fn_GetAllEmployeeFromDepartment() {
      this.LoadingPosition = true;
      this.SelectNamePosition = [];
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccessToken: this.$cookies.get("OneAccessToken"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "business/GetAllEmployeeFromAllDepartment",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.LoadingPosition = false;
          if (response.data.Status === "OK") {
            this.ItemsPosition = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.LoadingPosition = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetPolicy() {
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "policy/GetApiAllDetailPolicy",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.ItemPolicy = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetConsentGeneral() {
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "consent/GetApiAllDetailConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.ItemConsentGeneral = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetConsentGroup() {
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "group-consent/GetApiAllGroupConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.ItemConsentGroup = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_ConfirmEmployee(value) {
      for (var i in value) {
        delete value[i].Email;
      }
      this.SelectNamePosition = value;
      this.StatusBtn = 2;
      this.Fn_GetPolicy();
      this.Fn_GetConsentGeneral();
      this.Fn_GetConsentGroup();
    },
    async Fn_Save() {
      if (this.$refs.form.validate()) {
        if (this.ConsentType === "SentGeneral") {
          this.SelectConsentGroup = "";
        } else if (this.ConsentType === "SentGroup") {
          this.SelectConsentGeneral = "";
        }
        this.LoadingSentConsent = true;
        for (var i in this.SelectNamePosition) {
          delete this.SelectNamePosition[i].Email;
          delete this.SelectNamePosition[i].Mobile;
        }
        var payload = {
          UserName: this.$cookies.get("OneUsername"),
          BusinessId: this.$cookies.get("BusinessId"),
          AccountId: this.$cookies.get("OneAccountId"),
          Receiver: this.SelectNamePosition,
          ConsentGroupId: this.SelectConsentGroup,
          Consent: this.SelectConsentGeneral,
          PolicyId: this.SelectPolicy,
          UserId: this.$cookies.get("OneAccountId"),
          GroupSend: "POSTER",
        };
        var Headers = {
          AccountId: this.$cookies.get("OneAccountId"),
        };
        var dataEncode = await authorization.encodeDataNew(payload);
        var auth = await authorization.encodeDataNew(Headers);
        var headers = { Authorization: "Bearer " + auth };
        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE + "onechat/GetConsent",
            { Data: dataEncode },
            { headers }
          )
          .then((response) => {
            this.LoadingSentConsent = false;
            if (response.data.Status === "OK") {
              if (this.SelectConsentGroup === "") {
                this.DialogList = true;
              } else {
                this.DialogListGroup = true;
              }
              this.ItemsListConsent = response.data.Message;
            } else {
              this.LoadingSentConsent = false;
              Toast.fire({
                icon: "error",
                title: response.data.ErrorMessage,
              });
            }
          })
          .catch((error) => {
            this.LoadingSentConsent = false;
            if (error.response) {
              Toast.fire({
                icon: "error",
                title: error.response.data.ErrorMessage,
              });
            } else if (error.request) {
              Toast.fire({
                icon: "error",
                title: error.request,
              });
            } else {
              Toast.fire({
                icon: "error",
                title: error.message || error,
              });
            }
          });
      }
    },
    async Fn_SyncBot() {
      this.LoadingSync = true;
      const payload = {
        AccessToken: this.$cookies.get("OneAccessToken"),
        BusinessId: this.$cookies.get("BusinessId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "onechat/AddFrindBot",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.LoadingSync = false;
          if (response.data.Status === "OK") {
            Toast.fire({
              icon: "success",
              title: "Sync CMP Bot Success",
            });
            // window.location.reload();
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.LoadingSync = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_Importexcel() {
      this.LoadingExcel = true;
      this.$router.push("/upload-excel");
    },
  },
  created() {},
  watch: {
    TypeSent(val) {
      if (val === "SentAll") {
        this.$refs.formConsent.resetValidation();
        this.DisabledPosition = true;
      } else {
        this.ItemsPosition = [];
      }
    },
    SelectDepartment(val) {
      if (val.DepartmentId === "00000") {
        this.DepartmentId = "00000";
        this.$refs.formConsent.resetValidation();
        this.DisabledPosition = true;
      } else if (val.DepartmentId) {
        this.$refs.formConsent.resetValidation();
        this.DisabledPosition = false;
        this.Fn_GetDetailDepartment();
      }
    },
    SelectRole(val) {
      this.ItemsPosition = val.Account;
    },
    ConsentType(val) {
      if (val === "SentGeneral") {
        this.TextPolicy = "เลือกนโยบายแบบทั่วไป";
        this.TextConsent = "เลือกความยินยอมแบบทั่วไป";
      } else if (val === "SentGroup") {
        this.TextPolicy = "เลือกนโยบายแบบกลุ่ม";
        this.TextConsent = "เลือกความยินยอมแบบกลุ่ม";
      }
    },
  },
};
</script>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

.v-stepper__content {
  padding: 0 !important;
}

.c-border {
  border-style: solid;
  border-color: #87e8de !important;
  border-width: 1px;
}

.--text {
  color: #13c2c2;
}

.ff3296--text {
  color: #ff3296;
}
</style>

<style>
input#input-45,
input#input-50 {
  cursor: pointer !important;
}
</style>
